<script setup>
const props = defineProps({
  value: {
    type: Number,
    required: true,
  },
  color: {
    type: String,
    required: true,
  },
})

const cappedValue = computed(() => {
  if (props.value > 100) {
    return 100
  }
  if (props.value < 0) {
    return 0
  }
  return props.value
})
</script>
<template>
  <figure class="h-2 w-full rounded-lg bg-gray-300">
    <div
      class="relative h-full transition-all"
      :class="[
        { 'bg-yellow-400': color === 'yellow' },
        { 'bg-red-400': color === 'red' },
        { 'bg-green-400': color === 'green' },
        { 'bg-blue-400': color === 'blue' },
        { 'bg-secondary': color === 'purple' },
      ]"
      :style="{ width: cappedValue + '%' }"
    >
      <div class="absolute bottom-1/2 right-0 translate-x-1/2 translate-y-1/2">
        <slot name="indicator" />
        <div
          class="absolute -top-1 left-1/2 -translate-x-1/2 -translate-y-full"
        >
          <slot name="legend" />
        </div>
      </div>
    </div>
  </figure>
</template>
